// extracted by mini-css-extract-plugin
export var blockedMessage = "_8s-3";
export var blockedOverlay = "_8s-1";
export var fadeIn = "_8s-2";
export var hereLink = "_8s-0";
export var slideUp = "_8s-4";